import React from 'react'

const LayoutTableHead = () => {
    return (
        <thead className="TableHead SettingItem">
        <tr>
            <th className="leadName">Tenant</th>
            <th className="leadName">Loại layout</th>
            <th className="layoutBlock">Block</th>
            <th className="leadName">Thông tin</th>
            <th className="fieldTitle">Tiêu đề</th>
            <th className="leadName">Kiểu dữ liệu</th>
            <th className="leadName">Bắt buộc</th>
            <th className="leadName">Giá trị mặc định</th>
            <th className="leadName">Thứ tự</th>
            <th className="Actions text-center">Action</th>
        </tr>
        </thead>
    )
}

export default LayoutTableHead
